module.exports = __webpack_public_path__ + "img/orange_103.ce5428a8.png";